import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function formatDate(value) {
    if (!value) {
        return "—";
    }
    return new Intl.DateTimeFormat("en-NZ", {
        day: "numeric",
        month: "short",
        timeZone: "UTC",
        year: "numeric",
    }).format(new Date(`${value.slice(0, 10)}T12:00:00.000Z`));
}
export function formatDateTime(value, timeZone) {
    return new Intl.DateTimeFormat("en-NZ", {
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        month: "short",
        timeZone,
        year: "numeric",
    }).format(new Date(value));
}
export function formatAddress(rdm) {
    return [
        rdm.business.address.line1,
        rdm.business.address.line2,
        rdm.business.address.suburb,
        rdm.business.address.city,
        rdm.business.address.postcode,
    ]
        .filter(Boolean)
        .join(", ");
}
export function Result({ value }) {
    const labels = {
        fail: "Failed",
        not_applicable: "Not applicable",
        pass: "Passed",
        warn: "Attention",
    };
    return (_jsx("span", { className: `sp-status sp-status--${value}`, children: labels[value] }));
}
export function EmptyRow({ columns, label, }) {
    return (_jsx("tr", { children: _jsx("td", { className: "sp-muted", colSpan: columns, children: label }) }));
}
export function SectionFrame({ children, eyebrow, sectionKey, title, }) {
    return (_jsxs("section", { className: "sp-section", "data-section-key": sectionKey, children: [_jsx("p", { className: "sp-section__eyebrow", children: eyebrow }), _jsx("h2", { children: title }), children] }));
}
export function TemperatureTable({ readings, timeZone, }) {
    return (_jsxs("table", { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "When" }), _jsx("th", { children: "Reading" }), _jsx("th", { children: "Limit applied" }), _jsx("th", { children: "Result" }), _jsx("th", { children: "Performed by" }), _jsx("th", { children: "Approved note" })] }) }), _jsx("tbody", { children: readings.length === 0 ? (_jsx(EmptyRow, { columns: 6, label: "No readings in this period" })) : (readings.map((reading) => (_jsxs("tr", { children: [_jsx("td", { children: formatDateTime(reading.occurred_at_local, timeZone) }), _jsxs("td", { children: [reading.value.toLocaleString("en-NZ"), " ", reading.unit] }), _jsx("td", { children: reading.limit }), _jsx("td", { children: _jsx(Result, { value: reading.result }) }), _jsx("td", { children: reading.performer }), _jsx("td", { children: reading.manager_approved_note ?? "—" })] }, `${reading.occurred_at_local}:${reading.performer}:${reading.value}`)))) })] }));
}
